import { render, staticRenderFns } from "./Transfer.component.vue?vue&type=template&id=7859707a&"
import script from "./Transfer.component.vue?vue&type=script&lang=ts&"
export * from "./Transfer.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports